import { Link } from 'react-router-dom';

const translations = {
  en: {
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    deletion: 'Data Deletion',
    copyright: 'All rights reserved.'
  },
  fr: {
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
    deletion: 'Suppression des données',
    copyright: 'Tous droits réservés.'
  },
  nl: {
    privacy: 'Privacybeleid',
    terms: 'Servicevoorwaarden',
    deletion: 'Gegevensverwijdering',
    copyright: 'Alle rechten voorbehouden.'
  }
};

const Footer = ({ language }) => {
  const t = translations[language] || translations.en;
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 text-center text-sm text-gray-600 py-6">
      <div className="space-x-4 mb-2">
        <Link to="/privacy" className="hover:underline">{t.privacy}</Link>
        <Link to="/terms" className="hover:underline">{t.terms}</Link>
        <Link to="/datadeletion" className="hover:underline">{t.deletion}</Link>
      </div>
      <div>
        © {year} JRAutomation. {t.copyright}
      </div>
    </footer>
  );
};

export default Footer;
